import { render, staticRenderFns } from "./cartelera.vue?vue&type=template&id=6a9c0b5f&scoped=true"
import script from "./cartelera.vue?vue&type=script&lang=js"
export * from "./cartelera.vue?vue&type=script&lang=js"
import style0 from "./cartelera.vue?vue&type=style&index=0&id=6a9c0b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c0b5f",
  null
  
)

export default component.exports